import { useSelectorState, useSelectorValue } from '../../../common/providers/selectorProvider';
import DropdownCheckboxV3 from '../../../../../common/components/DropdownCheckboxV3';
import { getSelectedOption, useStoreName } from '../../hooks';


export default function StoreSelector({ tableName, disabled }) {
    const companySelected = useSelectorValue('initial_company');
    const regionSelected = useSelectorValue('initial_region');

    const { data, isLoading } = useStoreName(tableName, companySelected, regionSelected);
    const [initialSelectedStore, setInitialSelectedStore] = useSelectorState('initial_store')
    const loadingState = Boolean(isLoading || data === undefined);

    const optionListStore = (data || [])
        .map((storeName) => {
            return {
                value: storeName,
                label: storeName
            }
        })
        .flat()
        .filter((option) => option?.value !== "" && option?.label !== "")
        .sort((a, b) => a?.label?.localeCompare(b?.label));


    function handleSelectStore(data) {
        let result = data.map(a => a.value);
        setInitialSelectedStore(result)
        return result
    }

    return (
        <DropdownCheckboxV3
            id='store_filter'
            label='Store'
            options={optionListStore}
            disabled={isLoading}
            limitTags={1}
            value={getSelectedOption(initialSelectedStore, optionListStore) || []}
            onChange={(event, newValue) => {
                // setSelectedStores('store', 3)
                handleSelectStore(getSelectedOption(newValue, optionListStore))
            }}
            isLoading={loadingState}
            clearable={false}
        />
    )
}